(function () {
  const WORKING_HOURS_START = 10; // 10:00 AM
  const WORKING_HOURS_END = 17;   // 5:00 PM
  const SLOT_DURATION_MIN = 30;

  const REASONS = [
    "Order Status Enquiry",
    "Return / Exchange Request",
    "Payment Issue",
    "Product Information",
    "Complaint",
    "Other",
  ];

  const MIDDLEWARE_URL = "https://apis.arvindfashions.com/api/cta";

  /* ─── DOM refs ─── */
  const form           = document.getElementById("callbackForm");
  const dateSelect     = document.getElementById("preferredDate");
  const timeSelect     = document.getElementById("preferredTime");
  const reasonSelect   = document.getElementById("reasonSelect");
  const thankYou       = document.getElementById("thankYouScreen");
  const submitBtn      = form ? form.querySelector("button[type='submit']") : null;

  /* ─── Helpers ─── */

  function padZero(n) {
    return String(n).padStart(2, "0");
  }

  function formatDate(date) {
    // Returns YYYY-MM-DD
    return `${date.getFullYear()}-${padZero(date.getMonth() + 1)}-${padZero(date.getDate())}`;
  }

  function formatDateLabel(date) {
    // Returns "Mon, 13 May 2026"
    return date.toLocaleDateString("en-IN", {
      weekday: "short",
      day: "numeric",
      month: "short",
      year: "numeric",
    });
  }

  function formatSlotLabel(hour, minute) {
    const period = hour >= 12 ? "PM" : "AM";
    const h = hour > 12 ? hour - 12 : hour;
    const start = `${padZero(h)}:${padZero(minute)} ${period}`;

    let endHour = hour;
    let endMin  = minute + SLOT_DURATION_MIN;
    if (endMin >= 60) { endHour += 1; endMin -= 60; }
    const ePeriod = endHour >= 12 ? "PM" : "AM";
    const eh = endHour > 12 ? endHour - 12 : endHour;
    const end = `${padZero(eh)}:${padZero(endMin)} ${ePeriod}`;

    return `${start} – ${end}`;
  }

  function formatScheduledTime(dateStr, hour, minute) {
    // Returns "YYYY-MM-DD HH:MM:00" — matches Ozonetel expected format
    return `${dateStr} ${padZero(hour)}:${padZero(minute)}:00`;
  }

  /* ─── Populate Dates ─── */

  function populateDates() {
    if (!dateSelect) return;

    const today = new Date();

    for (let i = 0; i < 3; i++) {
      const d = new Date(today);
      d.setDate(today.getDate() + i);

      const option       = document.createElement("option");
      option.value       = formatDate(d);
      option.textContent = i === 0 ? `Today – ${formatDateLabel(d)}` : formatDateLabel(d);
      dateSelect.appendChild(option);
    }
  }

  /* ─── Populate Time Slots ─── */

  function populateTimeSlots(selectedDate) {
    if (!timeSelect) return;

    // Clear existing options except placeholder
    while (timeSelect.options.length > 1) {
      timeSelect.remove(1);
    }

    if (!selectedDate) return;

    const now          = new Date();
    const isToday      = selectedDate === formatDate(now);
    const currentHour  = now.getHours();
    const currentMin   = now.getMinutes();

    for (let h = WORKING_HOURS_START; h < WORKING_HOURS_END; h++) {
      for (let m = 0; m < 60; m += SLOT_DURATION_MIN) {
        // Skip past slots for today
        if (isToday) {
          if (h < currentHour) continue;
          if (h === currentHour && m <= currentMin) continue;
        }

        const option       = document.createElement("option");
        option.value       = formatScheduledTime(selectedDate, h, m);
        option.textContent = formatSlotLabel(h, m);
        timeSelect.appendChild(option);
      }
    }

    if (timeSelect.options.length === 1) {
      const option       = document.createElement("option");
      option.value       = "";
      option.textContent = "No slots available for today, please select another date";
      option.disabled    = true;
      timeSelect.appendChild(option);
    }
  }

  /* ─── Populate Reasons ─── */

  function populateReasons() {
    if (!reasonSelect) return;

    REASONS.forEach(function (reason) {
      const option       = document.createElement("option");
      option.value       = reason;
      option.textContent = reason;
      reasonSelect.appendChild(option);
    });
  }

  /* ─── Form Submit ─── */

  function handleSubmit(e) {
    e.preventDefault();

    const firstName = form.querySelector("[name='first_name']").value.trim();
    const lastName  = form.querySelector("[name='last_name']").value.trim();
    const phoneRaw  = form.querySelector("[name='phone']").value.trim();
    const phone     = phoneRaw.replace(/^\+91/, "").replace(/^91/, "").trim();
    const time      = form.querySelector("[name='preferred_time']").value;

    const fullName      = `${firstName} ${lastName}`.trim();
    const scheduledTime = time; // Already formatted as "YYYY-MM-DD HH:MM:00"

    const payload = { data: [[phone, fullName, scheduledTime]] };

    submitBtn.disabled    = true;
    submitBtn.textContent = "Submitting...";

    fetch(MIDDLEWARE_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    })
      .then(function (res) {
        if (!res.ok) throw new Error("Request failed with status " + res.status);
        return res.json();
      })
      .then(function (data) {
        console.log("Callback scheduled:", data);
        form.classList.add("hidden");
        thankYou.classList.remove("hidden");
        window.scrollTo({ top: 0, behavior: "smooth" });// ← fixes flicker-to-bottom
      })
      .catch(function (err) {
        console.error("Callback error:", err);
        submitBtn.disabled    = false;
        submitBtn.textContent = "Submit";
        alert("Something went wrong. Please try again.");
      });
  }

  /* ─── Event Listeners ─── */

  if (dateSelect) {
    dateSelect.addEventListener("change", function () {
      populateTimeSlots(this.value);
    });
  }

  if (form) {
    form.addEventListener("submit", handleSubmit);
  }

  /* ─── Init ─── */
  populateDates();
  populateReasons();
})();


// ─── Indian Phone Validation ───────────────────────────────────────────────

const phoneInput = document.querySelector('#callbackForm input[name="phone"]');
const INDIA_RE   = /^[6-9]\d{9}$/;

function renderPhoneError(msg) {
  const wrapper = phoneInput?.closest('.form-group');
  if (!wrapper) return;

  let errEl = wrapper.querySelector('.phone-error');
  if (!errEl) {
    errEl = document.createElement('span');
    errEl.className = 'phone-error';
    errEl.setAttribute('role', 'alert');
    errEl.setAttribute('aria-live', 'polite');
    wrapper.appendChild(errEl);
  }

  errEl.textContent = msg;
  phoneInput.classList.toggle('input-error',   !!msg);
  phoneInput.classList.toggle('input-success', !msg && normalizePhone(phoneInput.value).length === 10);
}

function normalizePhone(val) {
  // Step 1: strip all non-digit characters
  let digits = val.replace(/\D/g, '');

  // Step 2: strip country code by length — NOT by regex
  // 12 digits starting with 91 → strip first 2 (e.g. +919876543210 → 9876543210)
  if (digits.length === 12 && digits.startsWith('91')) {
    digits = digits.slice(2);
  }

  // Step 3: strip leading 0 (e.g. 09876543210 → 9876543210)
  if (digits.length === 11 && digits.startsWith('0')) {
    digits = digits.slice(1);
  }

  // Step 4: hard cap at 10 digits
  return digits.slice(0, 10);
}

function validatePhone(val) {
  if (!val || val.length === 0) return 'Mobile number is required.';
  if (val.length < 10)          return `Mobile number must be 10 digits. You entered ${val.length}.`;
  if (val.length > 10)          return 'Mobile number cannot exceed 10 digits.';
  if (!INDIA_RE.test(val))      return 'Enter a valid Indian mobile number (must start with 6–9).';
  return '';
}

if (phoneInput) {
  phoneInput.setAttribute('maxlength', '10');
  phoneInput.setAttribute('minlength', '10');
  phoneInput.setAttribute('inputmode', 'numeric');
  phoneInput.setAttribute('pattern', '[6-9][0-9]{9}');

  // ─── Block invalid first digit at keyboard level ───────────────────────
  phoneInput.addEventListener('keydown', function (e) {
    const currentLength = normalizePhone(this.value).length;
    const isDigitKey    = /^[0-9]$/.test(e.key);

    // Block non 6-9 on first position
    if (currentLength === 0 && isDigitKey && !/^[6-9]$/.test(e.key)) {
      e.preventDefault();
      renderPhoneError('Mobile number must start with 6, 7, 8, or 9.');
      return;
    }

    // Block typing beyond 10 digits
    if (currentLength >= 10 && isDigitKey) {
      e.preventDefault();
    }
  });

  // ─── Handle paste separately with setTimeout ───────────────────────────
  phoneInput.addEventListener('paste', function () {
    setTimeout(() => {
      const cleaned = normalizePhone(this.value);
      this.value    = cleaned;
      renderPhoneError(cleaned.length > 0 ? validatePhone(cleaned) : '');
    }, 0);
  });

  // ─── Input (covers autofill, typing, drag-drop) ────────────────────────
  phoneInput.addEventListener('input', function () {
    const cleaned = normalizePhone(this.value);
    this.value    = cleaned;
    if (cleaned.length > 0) renderPhoneError(validatePhone(cleaned));
    else renderPhoneError('');
  });

  // ─── Blur: always show error if incomplete or invalid ─────────────────
  phoneInput.addEventListener('blur', function () {
    renderPhoneError(validatePhone(normalizePhone(this.value)));
  });
}